import { PROFILE_DEFAULTS } from '../shared/designParamOptions';

// Saved results describe the model they were built on, not today's defaults.
const LEGACY = {
  odc_splitter: 8, mfat_splitter: null, fat_splitter: 8, subscribers_per_port: 64,
  odc_min_fats: 32, patch_panel_cores: 48, mfat_enable: true,
  fat_cable_cores: 24, max_fat_chain: 12, metro_cable_cores: 144, odc_cable_cores: 48,
  metro_microduct_type: null, odc_microduct_type: '8x5', fat_microduct_type: '8x5',
  max_cables_per_microduct: null, meter_drops: false,
};
const CURRENT = {
  ...LEGACY,
  odc_splitter: PROFILE_DEFAULTS.fat_per_port, mfat_splitter: PROFILE_DEFAULTS.mfat_splitter,
  fat_splitter: PROFILE_DEFAULTS.fat_capacity,
  subscribers_per_port: PROFILE_DEFAULTS.fat_per_port * PROFILE_DEFAULTS.fat_capacity,
  odc_min_fats: 4 * PROFILE_DEFAULTS.fat_per_port,
  patch_panel_cores: PROFILE_DEFAULTS.odc_patch_panel_max_cores, mfat_enable: PROFILE_DEFAULTS.mfat_enable,
  fat_cable_cores: PROFILE_DEFAULTS.fat_cable_cores, max_fat_chain: PROFILE_DEFAULTS.fat_cable_cores / 2,
  metro_cable_cores: PROFILE_DEFAULTS.metro_cable_cores, odc_cable_cores: PROFILE_DEFAULTS.odc_cable_cores,
  metro_microduct_type: PROFILE_DEFAULTS.metro_microduct_type,
  odc_microduct_type: PROFILE_DEFAULTS.odc_microduct_type, fat_microduct_type: PROFILE_DEFAULTS.fat_microduct_type,
  max_cables_per_microduct: 2,
};

export function capacityModel(summary) {
  const cm = summary?.capacity_model || {};
  const base = summary == null ? CURRENT : LEGACY;
  return Object.fromEntries(Object.entries(base).map(([key, fallback]) => {
    if (key.endsWith('_microduct_type')) {
      const size = cm[key] || (key === 'metro_microduct_type' ? null : cm.microduct_type);
      return [key, typeof size === 'string' && size ? size : fallback];
    }
    if (typeof fallback === 'boolean') return [key, typeof cm[key] === 'boolean' ? cm[key] : fallback];
    const value = cm[key] == null ? NaN : Number(cm[key]);
    const min = key === 'max_cables_per_microduct' || key === 'odc_min_fats' ? 0 : 1;
    return [key, Number.isFinite(value) && value >= min ? value : fallback];
  }));
}

// The 1:8 row is always shown for legacy results; other ratios need a real count.
export function splitterCounts(bom) {
  const b = bom || {};
  return [4, 8, 16, 32]
    .map((ratio) => [ratio, Number(b[`splitter_1x${ratio}`]) || 0])
    .filter(([ratio, count]) => ratio === 8 || count > 0);
}

export function dropsMetered(summary) {
  return Number(summary?.bom?.drop_cable_m) > 0;
}
